<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <employee-leaves-applications-approvals-table-list :employee-uid="employee.employee_uid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    components: {
      EmployeeLeavesApplicationsApprovalsTableList: () => import('@/components/employee/leaves/applications/approvals/TableList'),
    },
    metaInfo () {
      return {
        title: 'Leave Approval',        
      }
    },
    computed: {  
      ...mapState({ employee: 'currentEmployee' }),
    },
  }
</script>
